import type { FaireProductEntity } from "../../entity_types/product";

export const p_tzumkfxn68: FaireProductEntity = {
  token: "p_tzumkfxn68",
  type: "product",
  name: "ELEVATED - Natural Hand Sanitizer - with/withOUT moisturizer",
  brandToken: "b_b3ffvix4",
  brandName: "Taylor's Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/a665540582c83b146cc21b3a07c8641ebbf7d8f2205b932649e7ba2f34c881f1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4acc6999c29ef5701a578acb9e61b1288f98d7fc419adbdb53c81046da4d28c4.png",
    "https://cdn.faire.com/fastly/4f5b80a4466a32509a14c2c51868aa56fcb32c12945871dea4d3430fff3776db.png",
    "https://cdn.faire.com/fastly/efaef8f444e1f2e65c189bb57a311667336233bbe039cd9d323442533ec3c6e9.png",
    "https://cdn.faire.com/fastly/22054e6f3b1827184d67c6a0eb17804fbd2c6e2f099246f56a23e17d242f9eae.png",
    "https://cdn.faire.com/fastly/7cf10a7e16eb39049ff1a76cbe50d09c826947f71f2e3ea03588df0bf7bd12f2.png",
  ],
  priceDollars: 3.85,
  description:
    "***NOW available without special request.  PLEASE Choose With or WithOUT Moisture \n\nBlended with macadamia nut oil, this sanitizer moisturizes and leaves hands feeling silky smooth!\n\nChoose between 5 scents and with or withOUT moisturizer.\n\nMany years ago, when we started our business, we loathed hand sanitizers, but had such a high demand for one that we formulated a perfect hand sanitizer that didn't feel like it dried out your hands! \n\n•\tLeaves hands silky smooth!\n•\tAll Natural, Hand Crafted in the USA\n•\tPerfect for backpacks, diaper bags, purses, airports / airplanes, travel, grocery stores, gas stations, restaurants, public restrooms, diaper changes, baby, children's hands, and more!\n•\tVegan & Cruelty Free \n•\tComes in Recycled Aluminum with spray!\n\nSee separate listing for Refill and BULK Sizes!\n\nIngredients: 72% natural grain ethanol, virgin macadamia nut oil, and essential oil blend (blend depends on scent chosen). ** withOUT moisturizer does not have macadamia nut oil\n",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:28.378Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
